import { __assign } from '../../../../../../node_modules/tslib/tslib.es6.js';
import React__default, { useRef } from 'react';
import { MenuLink, HeadOption } from './styles.js';
import { Check } from '@mui/icons-material';
import { Box, Typography, useTheme } from '@mui/material';
import MenuDropDown from '../MenuDropDown/index.js';

var ServiceListOption = function (_a) {
    var isSubGroup = _a.isSubGroup, isCompactElements = _a.isCompactElements, _b = _a.route, onClick = _b.onClick, active = _b.active, name = _b.name, id = _b.id, sideElement = _b.sideElement;
    return (React__default.createElement(MenuLink, { onClick: onClick, id: id, isSubOption: !!isSubGroup },
        React__default.createElement(HeadOption, { isSubOption: isSubGroup, active: !!active, sx: isCompactElements ? { height: "38px" } : {} },
            React__default.createElement(Box, { display: "flex", alignItems: "center", gap: sideElement && "5px", justifyContent: isSubGroup ? "space-between" : "center", flex: 1 },
                React__default.createElement(Typography, { color: "inherit", fontWeight: "inherit", variant: "h3" }, name),
                sideElement,
                isSubGroup && !!active && React__default.createElement(Check, null)))));
};
var RouteDropdown = function (_a) {
    var id = _a.id, routes = _a.routes, secondaryTitle = _a.secondaryTitle, isCompactElements = _a.isCompactElements, title = _a.title;
    var menuDropDownRef = useRef(null);
    var theme = useTheme();
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(MenuDropDown, { id: id, ref: menuDropDownRef, secondaryTitle: secondaryTitle, title: title, dropDownStyle: __assign({ maxHeight: "300px" }, (isCompactElements
                ? {
                    paddingTop: "15px",
                    paddingBottom: "15px",
                    background: theme.palette.neutral800,
                }
                : {})), focused: routes.some(function (x) { return x.active; }) }, routes.map(function (r) { return (React__default.createElement(ServiceListOption, { isCompactElements: isCompactElements, isSubGroup: true, key: r.id, route: __assign(__assign({}, r), { onClick: function () {
                    var _a;
                    (_a = menuDropDownRef === null || menuDropDownRef === void 0 ? void 0 : menuDropDownRef.current) === null || _a === void 0 ? void 0 : _a.setIsDropDownActive(false);
                    r === null || r === void 0 ? void 0 : r.onClick();
                } }) })); }))));
};

export { RouteDropdown, ServiceListOption };
